<template>
  <el-row>
    <el-col :span="5">
      <basic-container>
        <el-tree
          class="filter-tree"
          :props="treeProps"
          node-key="id"
          ref="leftTreeRef"
          :load="lazyLoadLeftTree"
          :filter-node-method="filterNode"
          lazy
          @node-click="nodeClick"
          v-loading="loading"
        >
        </el-tree>
      </basic-container>
    </el-col>
    <el-col :span="19">
      <basic-container id="settingForm">
        <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0">
          <el-row>
            <el-col :span="8">
              <el-form-item label="车场名称" prop="parkingLotId">
                <el-select
                  v-model="parkingLotId"
                  placeholder="全部"
                  style="width: 100%"
                  @change="changeParkSpace"
                >
                  <el-option
                    v-for="item in spaceList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                    style="padding-left: 10px"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item>
                <el-button type="primary" @click="onLoad" icon="el-icon-search">搜索 </el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-divider></el-divider>
          </el-row>
        </el-form>
        <el-form
          ref="matchSettingForm"
          v-show="showMatchSettingForm"
          :model="matchSettingForm"
          label-width="230px"
          margin-top="20"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="开启车牌模糊匹配功能">
                <el-switch
                  v-model="matchSettingForm.plateMatchOpen"
                  :active-value="switchValue.yes"
                  :inactive-value="switchValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="font-size: 10px; margin-top: 7px">
                开启后车牌识别会使用车牌匹配规则进行匹配
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="开启车牌忽略首汉字匹配功能">
                <el-switch
                  v-model="matchSettingForm.ignoreFirstLetter"
                  :active-value="switchValue.yes"
                  :inactive-value="switchValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="font-size: 10px; margin-top: 7px">
                开启后车牌识别会使用忽略首汉字进行匹配车牌
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="忽略首汉字与字母匹配同时使用">
                <el-switch
                  v-model="matchSettingForm.matchPlus"
                  :active-value="switchValue.yes"
                  :inactive-value="switchValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="font-size: 10px; margin-top: 7px">
                开启后会同时忽略首汉字与匹配单个字母同时匹配
              </div>
            </el-col>
          </el-row>
        </el-form>

        <el-form
          ref="jobSettingForm"
          v-show="showJobSettingForm"
          :model="jobSettingForm"
          label-width="230px"
          margin-top="20"
          :rules="settingRules"
        >
          <el-row>
            <el-col offset="1">
              <h5>图片上传</h5>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="开启图片上传功能">
                <el-switch
                  v-model="jobSettingForm.openImageUpload"
                  :active-value="switchValue.yes"
                  :inactive-value="switchValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="font-size: 10px; margin-top: 12px">开启后客户端会定时上传图片</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="图片上传执行cron" prop="imageUploadCron">
                <el-input v-model="jobSettingForm.imageUploadCron"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="font-size: 10px; margin-top: 12px; padding-left: 20px">
                不配置则随机空闲时间执行
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3">
              <el-form-item label="图片压缩参数:" label-width="210px"> </el-form-item>
            </el-col>
            <el-col :span="3" offset="1">
              <el-form-item label="宽度" label-width="70px" prop="imageCompressWidth">
                <el-input type="number" v-model="jobSettingForm.imageCompressWidth"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="高度" label-width="70px" prop="imageCompressHeight">
                <el-input type="number" v-model="jobSettingForm.imageCompressHeight"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <div style="font-size: 10px; margin-top: 12px; padding-left: 20px">
                默认 600 * 380
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col offset="1">
              <h5>更新检查</h5>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="是否立即重启">
                <el-switch
                  v-model="jobSettingForm.autoRestartAfterUpdate"
                  :active-value="switchValue.yes"
                  :inactive-value="switchValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="font-size: 10px; margin-top: 12px">开启后客户端更新完毕立即自动重启</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="更新检查cron" prop="updateCheckCron">
                <el-input v-model="jobSettingForm.updateCheckCron"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <div style="font-size: 10px; margin-top: 12px; padding-left: 20px">
                客户端定时检查版本更新
              </div>
            </el-col>
          </el-row>
        </el-form>

        <el-form
          ref="otherSettingForm"
          v-show="showOtherSettingForm"
          :model="otherSettingForm"
          label-width="230px"
          margin-top="20"
          :rules="settingRules"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="是否启用服务端计费" prop="serverBilling">
                <el-switch
                  v-model="otherSettingForm.serverBilling"
                  :active-value="switchValue.yes"
                  :inactive-value="switchValue.no"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" offset="1">
              <div style="font-size: 10px; margin-top: 12px">默认客户端计费</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="场内缴费允许停留时间" prop="allowStayMinutes">
                <el-input type="number" v-model="otherSettingForm.allowStayMinutes">
                  <template slot="append">分钟</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" offset="1">
              <div style="font-size: 10px; margin-top: 12px">
                不配置则默认为15分钟，超过后重新计算停车费
              </div>
            </el-col>
          </el-row>
        </el-form>

        <el-form ref="submitForm" label-width="230px" margin-top="20">
          <el-row>
            <el-col offset="5">
              <el-form-item>
                <el-button
                  v-if="permissionList.saveBtn"
                  :disabled="buttonDisabled"
                  type="primary"
                  icon="el-icon-check"
                  @click="saveSetting"
                  style="width: 90px; height: 36px"
                  >保存
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </basic-container>
    </el-col>
  </el-row>
</template>

<script>
import { sync, getDetail, update } from '@/api/v4ward/park/car/carv4wardsettings';
import { getDictionary } from '@/api/common';
import { mapGetters } from 'vuex';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { cronValidator } from '@/util/validate';

export default {
  data() {
    var numberCheck = (rule, value, callback) => {
      if (typeof value !== 'number' && isNaN(value)) {
        callback(new Error('请输入数字！'));
      } else if (value < rule.min || value > rule.max) {
        callback(new Error('有效数据' + rule.min + '-' + rule.max + '！'));
      } else {
        callback();
      }
    };
    return {
      treeProps: {
        //标题
        label: 'dictValue',
        //值
        value: 'dictKey',
        //子节点
        children: 'children',
        //是否叶子节点
        isLeaf: 'isLeaf',
      },
      paramType: 0,
      showMatchSettingForm: false,
      showJobSettingForm: false,
      showOtherSettingForm: false,
      settings: '',
      buttonDisabled: false,
      parkingLotId: '',
      spaceList: [],
      click: false,
      query: {},
      formData: {},
      matchSettingForm: {
        plateMatchOpen: 0,
        ignoreFirstLetter: 0,
        matchPlus: 0,
      },
      otherSettingForm: {
        allowStayMinutes: 15,
        serverBilling: 0,
      },
      jobSettingForm: {
        openImageUpload: 0,
        imageUploadCron: '',
        imageCompressWidth: 600,
        imageCompressHeight: 380,
        autoRestartAfterUpdate: 1,
        updateCheckCron: this.randomCron(),
      },
      switchValue: { yes: 1, no: 0 },
      settingRules: {
        imageUploadCron: [
          { message: '请输入cron表达式', trigger: 'blur' },
          { message: '请输入cron表达式', trigger: 'change', validator: cronValidator },
        ],
        updateCheckCron: [
          { required: true, message: '请输入cron表达式', trigger: 'blur' },
          { message: '请输入正确的cron表达式', trigger: 'change', validator: cronValidator },
        ],
        imageCompressWidth: [
          { required: true, message: '请输入图片宽度', trigger: 'blur' },
          { validator: numberCheck, min: 100, max: 1000, trigger: 'blur' },
        ],
        imageCompressHeight: [
          { required: true, message: '请输入图片高度', trigger: 'blur' },
          { validator: numberCheck, min: 100, max: 1000, trigger: 'blur' },
        ],
        allowStayMinutes: [
          { required: true, message: '请输入停留时间', trigger: 'blur' },
          { validator: numberCheck, min: 5, max: 120, trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        saveBtn: this.vaildData(this.permission.carv4wardsettings_save, false),
        syncBtn: this.vaildData(this.permission.carv4wardsettings_sync, false),
      };
    },
  },

  created() {
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      // 默认查询第一个
      this.query.parkingLotId = this.spaceList[0].id;
      this.parkingLotId = this.spaceList[0].id;
      this.onLoad();
      this.click = true;
    });
  },
  methods: {
    changeParkSpace(value) {
      this.parkingLotId = value;
      this.onLoad();
    },
    refreshShowForm() {
      this.showMatchSettingForm = this.paramType === 1;
      this.showJobSettingForm = this.paramType === 2;
      this.showOtherSettingForm = this.paramType === 9;
    },
    //加载树
    lazyLoadLeftTree(node, resolve) {
      if (this.click) {
        return;
      }
      getDictionary('park_param_type').then((data) => {
        if (data.data.length > 0) {
          this.paramType = parseInt(data.data[0].dictKey);
        }
        data.data.forEach((type) => {
          type.isLeaf = true;
          type.children = null;
        });
        resolve(data.data);
        this.onLoad();
      });
      this.click = true;
    },
    //树节点过滤
    filterNode(value, data) {
      return true;
    },
    //点击左侧树结构回调
    nodeClick(data) {
      var intDictKey = parseInt(data.dictKey);
      if (this.paramType === intDictKey) {
        return;
      }
      this.paramType = intDictKey;
      this.onLoad();
    },
    onLoad() {
      if (parseInt(this.paramType) === 0 || this.vdui.isEmpty(this.parkingLotId)) {
        return;
      }
      this.refreshShowForm();
      getDetail({ parkingLotId: this.parkingLotId, paramType: this.paramType }).then(({ data }) => {
        this.formData = data;
        if (this.vdui.isNotEmpty(data.settings)) {
          if (this.paramType === 1) {
            this.matchSettingForm = JSON.parse(data.settings);
          } else if (this.paramType === 2) {
            this.jobSettingForm = JSON.parse(data.settings);
            if (
              this.vdui.isEmpty(this.jobSettingForm) ||
              this.vdui.isEmpty(this.jobSettingForm.updateCheckCron)
            ) {
              this.jobSettingForm.updateCheckCron = this.randomCron();
              this.jobSettingForm.autoRestartAfterUpdate = 1;
            }
            if (
              this.vdui.isEmpty(this.jobSettingForm) ||
              this.vdui.isEmpty(this.jobSettingForm.imageUploadCron)
            ) {
              this.jobSettingForm.imageUploadCron = this.randomCron();
            }
          } else if (this.paramType === 9) {
            this.otherSettingForm = JSON.parse(data.settings);
          }
        } else {
          this.matchSettingForm = {
            plateMatchOpen: 0,
            ignoreFirstLetter: 0,
            matchPlus: 0,
          };
          this.jobSettingForm = {
            openImageUpload: 0,
            imageUploadCron: this.randomCron(),
            imageCompressWidth: 600,
            imageCompressHeight: 380,
            autoRestartAfterUpdate: 1,
            updateCheckCron: this.randomCron(),
          };
          this.otherSettingForm = {
            allowStayMinutes: 15,
            serverBilling: 0,
          };
        }
      });
    },
    saveSetting() {
      var submitForm = this.setParam();
      if (submitForm == null) {
        return;
      }
      submitForm.validate((valid) => {
        if (valid) {
          //其它参数用新的form
          this.buttonDisabled = true;
          update(this.formData)
            .then((res) => {
              this.buttonDisabled = false;
              this.$message.success('修改成功!');
            })
            .catch((err) => {
              this.buttonDisabled = false;
            });
        }
      });
    },
    syncSetting() {
      var submitForm = this.setParam();
      if (submitForm == null) {
        return;
      }
      submitForm.validate((valid) => {
        if (valid) {
          this.buttonDisabled = true;
          //其它参数用新的form
          sync(this.formData)
            .then((res) => {
              this.buttonDisabled = false;
              this.$message.success('同步成功!');
            })
            .catch((err) => {
              this.buttonDisabled = false;
            });
        }
      });
    },
    setParam() {
      if (this.paramType === 1) {
        this.formData.settings = JSON.stringify(this.matchSettingForm);
        this.formData.remark = '系统配置-模糊匹配设置';
        return this.$refs.matchSettingForm;
      } else if (this.paramType === 2) {
        this.formData.settings = JSON.stringify(this.jobSettingForm);
        this.formData.remark = '系统配置-定时任务设置';
        return this.$refs.jobSettingForm;
      } else if (this.paramType === 9) {
        this.formData.settings = JSON.stringify(this.otherSettingForm);
        this.formData.remark = '系统配置-其它配置';
        return this.$refs.otherSettingForm;
      }
      return null;
    },
    randomCron() {
      var cron = '';
      cron = cron + Math.ceil(Math.random() * 60) + ' ';
      cron = cron + Math.ceil(Math.random() * 60) + ' ';
      cron = cron + Math.ceil(Math.random() * 7) + ' * * ? *';
      return cron;
    },
  },
};
</script>

<style>
#settingForm .el-input__inner {
  height: 30px;
  line-height: 30px;
}

#settingForm .el-form-item__content .el-input-group {
  vertical-align: middle;
}

#settingForm .el-input-group__append,
.el-input-group__prepend {
  padding: 0 5px;
}
</style>
